import React from 'react';

export const EnvBanner = () => {
    const isProd = Project.env === 'prod';
    
    if (!isProd) {
        return <header style={{ display: 'none' }}>{Project.env}</header>;
    }

    return null;
}